import {type SVGProps} from 'react';

export const CircleErrorFilledIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='currentColor'
        {...props}
    >
        <path
            d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.207 7.79297C15.8165 7.40244 15.1835 7.40244 14.793 7.79297L12 10.5859L9.20703 7.79297C8.81651 7.40244 8.18349 7.40244 7.79297 7.79297C7.40244 8.18349 7.40244 8.81651 7.79297 9.20703L10.5859 12L7.79297 14.793C7.40244 15.1835 7.40244 15.8165 7.79297 16.207C8.18351 16.5974 8.81655 16.5975 9.20703 16.207L12 13.4141L14.793 16.207C15.1835 16.5974 15.8165 16.5975 16.207 16.207C16.5975 15.8165 16.5974 15.1835 16.207 14.793L13.4141 12L16.207 9.20703C16.5975 8.81655 16.5974 8.18351 16.207 7.79297Z'
        />
    </svg>
);
